import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import { Button } from '../ui/button';


type Props = {
    title: string,
    content: string,
    onClose: () => void,
    onConfirm: () => void
    confirmText?: string,
    cancelText?: string
}

const CustomDialog = ({ title, content, onClose, onConfirm, confirmText = "Yes, Delete it", cancelText = "Cancel" }: Props) => {
    return (
        <div>
            <Dialog open={true} onClose={onClose}>
                <DialogTitle color='error'>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        component="div"
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                    <DialogActions sx={{ justifyContent: "space-between", width: "100%", p : 0, mt : 2 }}>

                        <Button onClick={onClose} variant="default">{cancelText}</Button>
                        <Button onClick={onConfirm} variant="error">{confirmText}</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default CustomDialog